import { create } from 'zustand';
import { clearAllDrafts } from '../lib/draftStorage';

export interface AuthUser {
  id: string;
  username: string;
  fullName: string;
  role: string;
  languagePreference: string;
  accountType: string;
  // null when accountType is FREE, or when a PAID account has valid access.
  paymentAccessReason: 'NEVER_PAID' | 'EXPIRED' | null;
}

interface AuthState {
  user: AuthUser | null;
  role: string | null;
  isAuthenticated: boolean;
  consentStatus: string | null;
  mustChangePassword: boolean;
  isFirstLogin: boolean;
  setAuth: (user: AuthUser, role: string, consentStatus: string, mustChangePassword: boolean, isFirstLogin: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  role: null,
  isAuthenticated: false,
  consentStatus: null,
  mustChangePassword: false,
  isFirstLogin: false,
  setAuth: (user, role, consentStatus, mustChangePassword, isFirstLogin) =>
    set({ user, role, isAuthenticated: true, consentStatus, mustChangePassword, isFirstLogin }),
  logout: () => {
    // Discard any in-progress authoring drafts so the next user on this browser
    // never sees the previous user's partially-filled forms. Covers explicit
    // sign-out AND session-expiry (the 401 interceptor calls logout() before
    // redirecting to /login). Scoped to `udb-draft-*` — leaves language pref and
    // auth flash (sessionStorage) untouched.
    clearAllDrafts();
    set({ user: null, role: null, isAuthenticated: false, consentStatus: null, mustChangePassword: false, isFirstLogin: false });
  },
}));
